module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.index === _vm.step) ? _c('div', [_c('step-title', {
    attrs: {
      "navItems": _vm.navItems,
      "index": _vm.index,
      "step": _vm.step
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container mt-3 pt-5 pb-5 bg-white"
  }, [_c('div', {
    staticClass: "card text-center border-0"
  }, [_c('div', {
    staticClass: "card-header border-0 bg-transparent"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-transparent",
    staticStyle: {
      "min-height": "45vh"
    }
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-muted border-0 bg-transparent"
  }, [_vm._t("footer", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('button', {
    staticClass: "btn btn-block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.prev()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/icon/step_back.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 offset-3"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.next()
      }
    }
  }, [_vm._v(_vm._s(_vm.step < _vm.navItems.length - 1 ? '下一步' : '完成'))])])])])], 2)])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-344baf12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/Step.vue
// module id = 716
// module chunks = 1